module.exports = __webpack_public_path__ + "img/logo.99c3b40f.svg";